import React from 'react';
import { Link } from 'react-router-dom';

const TokenList = props => {
    if (!props.data) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.data.length === 0) {
        return (
            <div className='empty'>
                No tokens...
            </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Txns (24H)</th>
                        <th>Volume (24H)</th>
                        <th>Holders</th>
                        <th>Issued</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.data.map((item, index) => {
                            return (
                                <tr key={item.symbol}>
                                    <td>{index + 1}</td>
                                    <td className="keyfield token-cell">
                                        <Link to={`/tokens/${item.symbol.toLowerCase()}`}>
                                            <img src={item.logo} />
                                            <span>{item.symbol}</span>
                                        </Link>
                                    </td>
                                    <td>{item.txns_24h}</td>
                                    <td>{item.volume_24h}</td>
                                    <td>{item.accounts}</td>
                                    <td>{item.total}</td>
                                    <td>{item.generated_status}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default TokenList;



// WEBPACK FOOTER //
// ./src/components/widgets/TokenList.js